import { memoSupports } from './memo.mjs';
var supportsLinearEasing = /*@__PURE__*/memoSupports(function () {
  try {
    document.createElement("div").animate({
      opacity: 0
    }, {
      easing: "linear(0, 1)"
    });
  } catch (e) {
    return false;
  }
  return true;
}, "linearEasing");
export { supportsLinearEasing };